import {HttpClient} from '@angular/common/http'
import {inject, Injectable, signal} from '@angular/core'
import {Router} from '@angular/router'
import {ICollectResult, IFFUser} from 'framfab-bankid-gw'
import {ReplaySubject} from 'rxjs'
import {environment} from '../../environments/environment'
import {ACCESS_TOKEN_KEY, LOCAL_STORAGE} from '../application/constants'

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public accessToken$ = new ReplaySubject<ICollectResult | null>(1)

  public user$ = signal<IFFUser | null>(null)

  private router = inject(Router)
  private readonly storage = inject(LOCAL_STORAGE)
  private readonly http = inject(HttpClient)

  public logout(): void {
    this.storage.removeItem(ACCESS_TOKEN_KEY)
    this.accessToken$.next(null)
    this.router.navigate(['/', 'login']).then()
  }

  public login(token: ICollectResult | null): void {
    if (!token) {
      return
    }
    this.storage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(token))
    this.accessToken$.next(token)
    const url = `${environment.bankIdGatewayUrl}/self`
    this.http.get<Required<IFFUser>>(url).subscribe({
      next: user => {
        this.user$.set(user)
      }
    })
  }
}
